export class AAConstant {
  public static CURRENT_LOCATION = 'Current location';
  public static MAX_PREVIOUSLY_SEARCHED_LOCATIONS = 10;
  public static MIN_CHARS_ENTRY_FOR_SEARCH = 5;
  public static MIN_CHARS_ENTRY_FOR_TRAFFIC_NEWS_SEARCH = 2;
  public static PROMO_BANNER_COMPONENT_NAME = 'PromotionOfferBannerHeadlessComponent';
  public static ROAD_SALES_MAIN = 'road-sales-main';
}

export class AppError {
  static ROUTE_LOCATION_MISSING = 'Please enter a location';
  static LOCATION_ERROR = "Your browser doesn't currently allow location sharing. Please enable this if you wish to access this feature.";
  static LOCATION_ACCESS_DENIED = 'Current location not supported.';
  static LOCATION_ACCESS_FEATURE_TURNON = 'Turn on location sharing to use this feature';
  static VIA_ROUTE_MAXIMUM = 'Maximum of 4 via points.';
  static VIA_ROUTE_MISSING = 'Please enter a location';
  static ROUTE_LOCATION_NOT_FOUND = 'Location not found';
  static NO_ROUTE_FOUND = 'Sorry, no route could be found between your chosen places. Please try alternative locations.';
  static LOCATION_ACCESS_DENIED_ERR = 'Your location has denied***';
  static INVALID_SITECORE_RESPONSE = 'Invalid sitecore response';
  static readonly FROM_CORD_MISSING = 'Enter your starting point';
  static readonly TO_CORD_MISSING = 'Enter your destination';
}

const AdSizes = {
  'routeplanner_top-right': [
    {
      viewPortSize: [1500, 0],
      adSize: [
        [970, 90],
        [728, 90],
        [320, 100]
      ]
    },
    {
      viewPortSize: [1300, 0],
      adSize: [
        [728, 90],
        [320, 100]
      ]
    },
    {
      viewPortSize: [768, 0],
      adSize: [[320, 100]]
    },
    {
      viewPortSize: [0, 0],
      adSize: []
    }
  ],
  'routeplanner_sidebar-left': [
    {
      viewPortSize: [1300, 0],
      adSize: [
        [336, 336],
        [336, 280],
        [300, 250]
      ]
    },
    {
      viewPortSize: [768, 0],
      adSize: [
        [336, 280],
        [300, 250],
        [336, 336],
      ]
    },
    {
      viewPortSize: [0, 0],
      adSize: [
        [300, 250],
        [336, 280],
        [336, 336]
      ]
    }
  ],
  routeplanner_below: [
    {
      viewPortSize: [1300, 0],
      adSize: [
        [970, 250],
        [970, 90],
        [728, 90]
      ]
    },
    {
      viewPortSize: [768, 0],
      adSize: [[728, 90]]
    },
    {
      viewPortSize: [0, 0],
      adSize: []
    }
  ],
  'routeplanner_mobile-bottom': [
    {
      viewPortSize: [768, 0],
      adSize: []
    },
    {
      viewPortSize: [0, 0],
      adSize: [
        [300, 50],
        [320, 50],
        [300, 60]
      ]
    }
  ],
  'routeplanner_mobile-top': [
    {
      viewPortSize: [768, 0],
      adSize: []
    },
    {
      viewPortSize: [0, 0],
      adSize: [
        [300, 50],
        [320, 50],
        [300, 60]
      ]
    }
  ]
};

export const GoogleAdsList = {
  BILLBOARD: {
    name: 'routeplanner_below',
    resolution: [
      [970, 250],
      [970, 90],
      [728, 90]
    ],
    sizes: AdSizes['routeplanner_below'],
    id: 'div-gpt-ad-1762345890087-0',
    minWidth: '970px',
    minHeight: '250px'
  },
  LEADERBOARD: {
    name: 'routeplanner_top-right',
    resolution: [
      [728, 90],
      [970, 90],
      [320, 100]
    ],
    sizes: AdSizes['routeplanner_top-right'],
    id: 'div-gpt-ad-1762346479237-0',
    minHeight: '100px'
  },
  LEADERBOARD2: {
    name: 'routeplanner_top-right',
    resolution: [
      [728, 90],
      [970, 90],
      [320, 100]
    ],
    sizes: AdSizes['routeplanner_top-right'],
    id: 'div-gpt-ad-1762346479237-0',
    minWidth: '970px',
    minHeight: '100px'
  },
  MOBILELEADERBOARD: {
    name: 'routeplanner_top-right',
    resolution: [
      [728, 90],
      [970, 90],
      [320, 100]
    ],
    sizes: AdSizes['routeplanner_top-right'],
    id: 'div-gpt-ad-1762346479237-0',
    minWidth: '970px',
    minHeight: '100px'
  },
  SIDEMPU: {
    name: 'routeplanner_sidebar-left',
    resolution: [
      [300, 250],
      [336, 280],
      [336, 336]
    ],
    sizes: AdSizes['routeplanner_sidebar-left'],
    id: 'div-gpt-ad-1762346351138-0',
    minWidth: '336px',
  },
  MPUMOBILE: {
    name: 'routeplanner_mobile-bottom',
    resolution: [
      [300, 50],
      [320, 50],
      [320, 60]
    ],
    sizes: AdSizes['routeplanner_mobile-bottom'],
    id: 'div-gpt-ad-1762346193381-0',
    minWidth: '320px',
    minHeight: '100px'
  },
  TOPMOBILE: {
    name: 'routeplanner_mobile-top',
    resolution: [
      [300, 50],
      [320, 50],
      [300, 100],
      [320, 100]
    ],
    sizes: AdSizes['routeplanner_mobile-top'],
    id: 'div-gpt-ad-1762346593870-0',
    minWidth: '320px'
    // minHeight: '100px'
  },
  INTERSTITIAL: {
    name: 'routeplanner_interstitial',
    id: 'div-gpt-ad-1788445034224-0',
  }
};

export const UnleashFlags = {
  autoRefresh: 'auto-refresh',
  reTriggerConsentBanner: 'ReTriggerConsentBanner',
  betaFeatures: 'beta-features',
  AlternateAdLoading:'AlternateAdLoading',
  InterstitialAd:'routeplanner.landing.web.interstitialAd'
};

export const SideBarLeftAdditonalSizes = [
  {
    viewPortSize: [1300, 0],
    adSize: [
      [160, 600],
      [300, 600],
      [300, 250],
      [320, 50],
      [320, 100]
    ]
  },
  {
    viewPortSize: [768, 0],
    adSize: [
      [336, 280],
      [300, 250],
      [336, 336]
    ]
  },
  {
    viewPortSize: [0, 0],
    adSize: [
      [300, 250],
      [336, 280],
      [336, 336]
    ]
  }
];

